<template>
  <div>
    <page-header
      :page="page"
      @onReturn="() => $router.back()"
      :has-return="true"
    />
    <filter-manager
      ref="filterRef"
      class="search-bar"
      search-icon="fa fa-sync pr-2"
      search-text="Procesar"
      search-container-class="d-flex align-items-center justify-content-end"
      v-model="model.search.filters"
      :display-advanced="false"
      :disabled-search="!canQueue"
      :filters="filterManagerConfig"
      @search="onProcessHandler"
    />
    <queue-report-status
      :queue-report="queueInfo"
      @on-cancel="cancelQueue"
      @on-download="downloadQueueReport"
    />
  </div>
</template>

<script>
import Vue from 'vue';

// components libs
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';

// components
import QueueReportStatus from '@/views/progress/shared/components/QueueReportStatus.vue';

// services
import DocumentServices from '@//modules/report/document';
import AcademicYearServices from '@/services/api/academicyear.api';
import ReportServices from '@/modules/report/api';
import hubservice from '@/services/api/hub/hubservice.js';

// constants
import queueReportTypes from '@/utils/constants/queueReportTypes';
import queueReportStatus from '@/utils/constants/queueReportStatus';

export default {
  components: {
    PageHeader,
    FilterManager,
    QueueReportStatus,
  },
  data: () => ({
    queueInfo: null,
    model: {
      search: {
        collections: {
          academicYears: [],
        },
        filters: {
          academicYears: null,
        },
      },
    },
  }),
  computed: {
    page() {
      return {
        icon: 'fas fa-clipboard-list-check',
        title: 'Define PEI - Preguntas Adicionales',
        routes: ['Informes', 'Define PEI - Preguntas Adicionales'],
      };
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          error: 'El año académico es requerido.',
          validations: 'required',
          clearable: false,
          class: 'col-12 col-md-12',
          options: this.model.search.collections.academicYears,
          value: this.model.search.filters.academicYears,
        },
      ];
    },
    canQueue() {
      return (
        this.queueInfo === null ||
        this.queueInfo.statusId === queueReportStatus.Completed ||
        this.queueInfo.statusId === queueReportStatus.Failed
      );
    },
  },
  created() {
    Vue.use(hubservice);
    this.$userHub.$on(
      'hub-receive-status-queue-report',
      this.updateReceivedQueueStatusByHub
    );
  },
  beforeDestroy() {
    this.$userHub.$off(
      'hub-receive-status-queue-report',
      this.updateReceivedQueueStatusByHub
    );
  },
  async mounted() {
    await this.getInitialFilters();
    const res = await ReportServices.getPreviousGeneratedReport([
      queueReportTypes.InformeDefinePEIPreguntasAdicionalesExcel,
    ]);
    this.queueInfo = res.data !== '' ? res.data : null;
  },
  methods: {
    async getInitialFilters() {
      this.model.search.collections.academicYears = (
        await AcademicYearServices.getCurrentPreviousAcademicYear()
      ).data;
    },
    async onProcessHandler() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      const {
        id: academicYearId,
        name: academicYearName,
      } = this.model.search.filters.academicYear;
      const fileName = `InformeDefinePEIPreguntasAdicionales-${academicYearName}.xlsx`;
      const reportName = `InformeDefinePEIPreguntasAdicionales_${academicYearId}.xlsx`;
      await ReportServices.getReport('peiadditionalquestions', {
        DirectoryName: 'pei-additional-question-reports',
        ReportName: reportName,
        FileName: fileName,
      }).then((res) => DocumentServices.Download(res.data));
    },
    async downloadQueueReport(executionLogId) {
      ReportServices.downloadQueueReport(executionLogId)
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    async cancelQueue(executionLogId) {
      ReportServices.cancelQueueReport(executionLogId)
        .then((res) => {
          if (res.data) {
            this.ShowToast(
              'Proceso Exitoso',
              'La ejecución del reporte ha sido cancelada exitosamente.',
              'success'
            );
            this.queueInfo = null;
          }
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    updateReceivedQueueStatusByHub(res) {
      this.queueInfo = res.respose;
    },
  },
};
</script>
